// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pp-container{max-width:1320px;padding-left:16px;padding-right:16px}@media (min-width:775px){.pp-container{padding-left:12.5%;padding-right:12.5%}}.pp-container a{color:var(--v-accentBlue-base)}.pp-container table{border:1px solid var(--v-accentLight-base);border-collapse:collapse}.pp-container table td{border-top:1px solid var(--v-accentLight-base);padding:6px 24px}", ""]);
// Exports
module.exports = exports;
